import type { FetchConfig } from '@nlo/nuxt-common/api/helper-types';
import type { components, paths } from '../../generated/portal-api';

export function createEnrichmentLotteryApi(fetchConfig: FetchConfig) {
	const client = fetchConfig.createClient<paths>();

	return {
		getContactPreferences() {
			return client.GET('/api/my/enrichment-lottery/profile');
		},
		updateProfile(props: components['schemas']['EnrichmentLotteryUpdateProfileViewModel'] & { vertical: VerticalTheme }) {
			return client.POST(`/api/my/enrichment-lottery/profile`, { body: props });
		},
	};
}
